export default __webpack_public_path__ + "static/media/Shadowy.0d85bdf8.jpg";